import React from 'react';

const AWSSkills = () => {
    return (
        <React.Fragment>
            <div className="block-title">
                <h3>Amazon Web Services Skills</h3>
            </div>
            <div className="skills-info">
                <h4>Amazon S3</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>AWS Elastic Beanstalk</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-4" />
                </div>
                <h4>Amazon Elastic Compute Cloud</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-4" />
                </div>
                <h4>Amazon Relational Database Service (RDS)</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>Amazon Cloudwatch</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>AWS Lambda</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>Amazon SNS</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-2" />
                </div>
                <h4>AWS CloudFormation</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
                <h4>AWS Codepipeline</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-6" />
                </div>
                <h4>Amazon DynamoDB</h4>
                <div className="skill-container">
                    <div className="skill-percentage skill-3" />
                </div>
            </div>
        </React.Fragment>
    );
};

export default AWSSkills;